import { getContext } from '@fiverr-private/fiverr_context';
import { mixpanel } from '@fiverr-private/obs';
import { PACKAGE_NAME } from '../../constants';

export const sendMixpanelEvent = (eventName: string, params: Record<string, any> = {}) => {
    const { userId, userGuid, organizationId } = getContext();

    mixpanel.track(eventName, {
        'User Id': userId,
        'Organization Id': organizationId,
        'User Guid': userGuid,
        'Source component': PACKAGE_NAME,
        ...params,
    });
};
